import { Source } from 'enums'

export const OVERVIEW_COLOR_SETTINGS: Record<string, Record<string, string>> = Object.freeze({
  Mentions: {
    positive_other: 'semantic.positive',
    negative_other: 'semantic.negative',
    neutral_other: 'semantic.neutral'
  },
  Posts: {
    video_other: 'metric.subMetrics.post.videos',
    image_other: 'metric.subMetrics.post.images',
    other: 'metric.subMetrics.post.other'
  },
  NetSentiment: {
    netSentiment: 'metric.mainMetrics.netSentiment',
    positive_other: 'semantic.positive',
    negative_other: 'semantic.negative'
  },
  PassionIntensity: {
    passionIntensity: 'metric.mainMetrics.passionIntensity'
  },
  Engagements: {
    comment_other: 'metric.subMetrics.totalEngagement.comments',
    like_other: 'metric.subMetrics.totalEngagement.likes',
    share_other: 'metric.subMetrics.totalEngagement.shares',
    view_other: 'metric.subMetrics.totalEngagement.views',
    score_other: 'metric.subMetrics.totalEngagement.score'
  },
  EngagementRatio: {
    engagementRatio: 'metric.mainMetrics.engagementsPerPost'
  },
  Impressions: {
    potentialImpression: 'metric.mainMetrics.potentialImpressions'
  },
  UniqueAuthors: {
    male: 'semantic.male',
    female: 'semantic.female',
    unknown: 'semantic.neutral'
  }
})

export const CONVERGED_MEDIA_COLOR_SETTINGS: Record<string, string> = Object.freeze({
  owned: 'metric.subMetrics.convergedMedia.owned',
  partnered: 'metric.subMetrics.convergedMedia.partnered',
  earned: 'metric.subMetrics.convergedMedia.earned'
})

export const DOMAIN_COLOR_SETTINGS: Record<string, string> = {
  [Source.TWITTER]: 'source.twitter',
  [Source.FACEBOOK]: 'source.facebook',
  [Source.INSTAGRAM]: 'source.instagram',
  [Source.YOU_TUBE]: 'source.youtube',
  [Source.TIKTOK]: 'source.tiktok',
  [Source.OTHER]: 'source.other',
  [Source.BLUESKY]: 'source.bluesky',
  [Source.REDDIT]: 'source.reddit'
}
